import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import Footer from "../../components/Footer/Footer";
import Seo from "../../components/Seo/Seo";
import classes from "./NotFound.module.css";

export default function NotFoundPage() {
  return (
    <main className="page">
      <Seo
        title="Page not found | DigitaliNation"
        description="That page is not on digitalination.com. Visit the homepage or browse services."
        noindex
      />
      <div className={classes.page}>
        <Container>
          <div className="sectionEyebrow">404</div>
          <h1 className="sectionTitle">Page not found</h1>
          <p className="sectionLead">
            That address is not a page on digitalination.com. The homepage and
            the service pages are the best place to start.
          </p>
          <div className={classes.actions}>
            <Link className="buttonHome" to="/">
              Back home
            </Link>
            <Link className="buttonHomeOutline" to="/services">
              Browse services
            </Link>
          </div>
        </Container>
      </div>
      <Footer />
    </main>
  );
}
